import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import authRoute from "@/router/auth/index";
import tryOutRoute from "@/router/try-out";
import drillingSoalRoute from "@/router/drilling-soal";
import materiRoute from "@/router/materi";
import kontribusiPengguna from "@/router/kontribusi-pengguna";
import othersRoute from "@/router/others";
import pembahasan from "@/router/pembahasan";
import transaksi from "@/router/transaksi";
import video from "@/router/video";
import event from "@/router/event";
import perbandingan from "@/router/perbandingan";

import repository from "@repofactory";
import group from "./group";
const authRepo = repository.get("auth");

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/menu/new-dashboard/Dashboard.vue"),
      meta: {
        pageTitle: "Dashboard",
        requireAuth: true,
      },
    },
    {
      path: "/detail-ranking/:id/:name",
      name: "detail-ranking",
      component: () => import("@/views/menu/new-dashboard/DetailRanking.vue"),
      meta: {
        pageTitle: "Dashboard",
      },
    },
    ...authRoute,
    ...tryOutRoute,
    ...drillingSoalRoute,
    ...materiRoute,
    ...kontribusiPengguna,
    ...pembahasan,
    ...othersRoute,
    ...transaksi,
    ...video,
    ...event,
    ...perbandingan,
    ...group,
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach(async (to, _, next) => {
  if (to.name === "detail-ranking") {
    to.meta.breadcrumb = [
      {
        text: `${to.params.name}`,
        active: true,
      },
    ];
  }

  if (to.path.includes("event")) {
    to.meta.pageTitle = to.params.name;
  }

  // const isLogin = store.state.auth.isLogin;
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refresh_token");

  if (to.meta.requireAuth) {
    if (token) {
      if (!store.state.auth.isLogin) {
        try {
          await store.dispatch("auth/user");
        } catch (e) {
          console.error("Token invalid, redirect login");
          localStorage.removeItem("token");
          next({ name: "login" });
          return;
        }
      }
      next();
    } else if (refreshToken) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    if (to.name === "login" && store.state.auth.isLogin) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
